@if (model?.tabs?.length) {
  <div class="tab-navigation">
    @for (tab of model.tabs; track tab.id) {
      <div class="tab zero-text p-small-reg no-select text-nowrap" [class.active]="tab.active" (click)="onTabChange(tab.id)">
        {{ tab.id | transloco }}
      </div>
    }
  </div>
}
